import { CONTACT } from "@/lib/constants";

const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="bg-black"
        >
            <div className="px-6 md:px-12 lg:px-16 py-10 grid grid-cols-12 gap-6 border-b border-white/10">
                <div className="col-span-12 md:col-span-4">
                    <div className="flex items-center gap-3">
                        <span className="block w-2.5 h-2.5 bg-[#1A9EC9]" />
                        <span className="font-display text-2xl uppercase tracking-tighter">
                            Terah
                        </span>
                    </div>
                    <p className="mt-4 font-mono text-xs text-white/50 leading-relaxed max-w-xs">
                        Ingeniería de infraestructura crítica. Seguridad,
                        conectividad y energía para empresas serias.
                    </p>
                </div>

                <div className="col-span-6 md:col-span-3">
                    <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4">
                        Servicios
                    </div>
                    <ul className="space-y-2 font-mono text-xs text-white/70">
                        <li>CCTV</li>
                        <li>Control de Acceso</li>
                        <li>Contra Incendios</li>
                        <li>Voz &amp; Datos</li>
                        <li>Domótica</li>
                        <li>Energía</li>
                    </ul>
                </div>

                <div className="col-span-6 md:col-span-3">
                    <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4">
                        Contacto
                    </div>
                    <ul className="space-y-2 font-mono text-xs text-white/70 break-words">
                        <li>{CONTACT.phone}</li>
                        <li>{CONTACT.email}</li>
                        <li>{CONTACT.address}</li>
                        <li>{CONTACT.city}</li>
                    </ul>
                </div>

                <div className="col-span-12 md:col-span-2">
                    <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4">
                        Social
                    </div>
                    <ul className="space-y-2 font-mono text-xs">
                        <li>
                            <a
                                href={CONTACT.instagram}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="social-instagram"
                                className="text-white/70 hover:text-[#1A9EC9]"
                            >
                                Instagram ↗
                            </a>
                        </li>
                        <li>
                            <a
                                href={CONTACT.linkedin}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="social-linkedin"
                                className="text-white/70 hover:text-[#1A9EC9]"
                            >
                                LinkedIn ↗
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="px-6 md:px-12 lg:px-16 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-white/40">
                    © {year} Terah · Todos los derechos reservados
                </p>
                <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-white/40">
                    Hecho con ingeniería y obsesión por el detalle.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
